// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__1ibDu","title":"Images45_title__3eSVN","images":"Images45_images__1wCyr"};